import { render, staticRenderFns } from "./PrintHeaderSSP.vue?vue&type=template&id=36d66cee&scoped=true"
import script from "./PrintHeaderSSP.vue?vue&type=script&lang=js"
export * from "./PrintHeaderSSP.vue?vue&type=script&lang=js"
import style0 from "./PrintHeaderSSP.vue?vue&type=style&index=0&id=36d66cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d66cee",
  null
  
)

export default component.exports